// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JBP2IyQWZpQnWR710P2w,.IE3VjaKfmd46RxAIZy5u{flex-direction:column;gap:4px;padding:4px 24px 16px;display:flex}.IE3VjaKfmd46RxAIZy5u{gap:24px;padding-top:0}.mAJ2OXvBUYHc1_V9zuv8{justify-content:flex-end;padding:16px 24px 24px;display:flex}.pDvWqRNFp88bFYPlfUc0{align-items:center;gap:8px;margin-left:auto;display:flex}.ZmKlK19ZV41c6E2aWQIL:empty{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `JBP2IyQWZpQnWR710P2w`,
	"duringCallContent": `IE3VjaKfmd46RxAIZy5u`,
	"footer": `mAJ2OXvBUYHc1_V9zuv8`,
	"footerRight": `pDvWqRNFp88bFYPlfUc0`,
	"alertContainer": `ZmKlK19ZV41c6E2aWQIL`
};
export default ___CSS_LOADER_EXPORT___;
